<template>
  <span class="grey--text" v-if="hasDateValue">
    {{ selectModel(modelValue, dataSelectorKey) | datetime }} ({{
      selectModel(modelValue, dataSelectorKey) | fromNow
    }})
  </span>
  <span v-else>--</span>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import ModelVue from "../../ModelVue";

@Component({
  components: {},
})
export default class FCellDateTime extends ModelVue {
  @Prop()
  dataSelectorKey: string;

  get hasDateValue() {
    return !!this.selectModel(this.modelValue, this.dataSelectorKey);
  }
}
</script>
